<template>
    <div id="add-addresslist">
        <van-tabs v-model="index" swipeable>
            <van-tab title="常用发货地址">
                <van-cell-group class="address-list">
                    <van-cell v-for="item in sendList" :key="item.id" class="address-item">
                        <van-row>
                            <van-col span="5" class="address-name">{{item.name}}</van-col>
                            <van-col span="12" class="address-phone">{{item.concatPhone}}</van-col>
                            </van-row>
                        <van-row class="address">{{item.provinceName+item.cityName+item.districtName+item.address}}</van-row>
                        <van-row class="btn">
                            <van-col span="12"><span style="display:block;height:100%;width:100%;" @click="edit(item.id)"><van-icon name="edit"/>编辑</span></van-col>
                            <van-col span="12"><span style="display:block;height:100%;width:100%;" @click="del(item.id)"><van-icon name="delete"/>删除</span></van-col>
                        </van-row>
                    </van-cell>
                </van-cell-group>
            </van-tab>
            <van-tab title="常用收货地址">
                <van-cell-group class="address-list">
                    <van-cell v-for="item in acceptList" :key="item.id" class="address-item">
                        <van-row>
                            <van-col span="5" class="address-name">{{item.name}}</van-col>
                            <van-col span="12" class="address-phone">{{item.concatPhone}}</van-col>
                            </van-row>
                        <van-row class="address">{{item.provinceName+item.cityName+item.districtName+item.address}}</van-row>
                        <van-row class="btn">
                            <van-col span="12"><span style="display:block;height:100%;width:100%;" @click="edit(item.id)"><van-icon name="edit"/>编辑</span></van-col>
                            <van-col span="12"><span style="display:block;height:100%;width:100%;" @click="del(item.id)"><van-icon name="delete"/>删除</span></van-col>
                        </van-row>
                    </van-cell>
                </van-cell-group>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "AllAddressList",
  data() {
    return {
      index: 0
    };
  },
  computed: {
    sendList() {
      return this.$store.getters.getAddress("1");
    },
    acceptList() {
      return this.$store.getters.getAddress("2");
    }
  },
  methods: {
    edit(id) {
      this.$router.push("/editAddress/" + (this.index + 1) + "/" + id);
    },
    del(id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "是否确认删除该地址？"
      })
        .then(() => {
          this.$store.dispatch({
            type: "delAddress",
            t: this.index,
            id
          });
        })
        .catch(() => {
          return false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#add-addresslist {
  .address-list {
    padding-top: 0.25rem;
    .address-item {
      margin-bottom: 0.25rem;
      border: 1px solid #ddd;
      .address {
        color: #999;
      }
      .btn {
        border-top: 1px solid #ddd;
        margin-top: 0.25rem;
        padding: 0.25rem 0 0;
        text-align: center;
        .van-icon {
          position: relative;
          top: 2px;
          right: 3px;
        }
      }
    }
  }
}
</style>
